var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardsBackgroundSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 237,
    viewBox: "0 0 422 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.373 -16.229C166.521 -25.961 107.114 -53.2647 82.1416 -65.7C67.6842 -72.4584 28.8331 -86.9482 -10.9118 -90.841C-60.5928 -95.707 -123.68 12.156 -85.0391 94.067C-46.3982 175.978 168.098 146.782 189.39 136.239C210.682 125.696 204.373 81.091 247.745 67.304C291.117 53.517 359.725 88.39 410.194 67.304C460.664 46.218 251.688 -4.06405 204.373 -16.229Z",
    fill: "url(#paint0_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.267 -1.42878C125.699 -8.011 85.5711 -26.4778 68.7032 -34.8884C58.9376 -39.4594 32.6948 -49.2596 5.84828 -51.8925C-27.7099 -55.1836 -70.3234 17.7694 -44.2226 73.1698C-18.1218 128.57 126.764 108.823 141.146 101.693C155.528 94.562 151.267 64.3935 180.564 55.0686C209.861 45.7438 256.203 69.3301 290.294 55.0686C324.384 40.8072 183.227 6.79901 151.267 -1.42878Z",
    fill: "url(#paint1_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.267 -1.42878C125.699 -8.011 85.5711 -26.4778 68.7032 -34.8884C58.9376 -39.4594 32.6948 -49.2596 5.84828 -51.8925C-27.7099 -55.1836 -70.3234 17.7694 -44.2226 73.1698C-18.1218 128.57 126.764 108.823 141.146 101.693C155.528 94.562 151.267 64.3935 180.564 55.0686C209.861 45.7438 256.203 69.3301 290.294 55.0686C324.384 40.8072 183.227 6.79901 151.267 -1.42878Z",
    fill: "url(#paint2_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.42 124.5C285.752 115.3 313.219 103.333 326.66 98.5C331.033 132.833 337.155 204.5 326.66 216.5C313.543 231.5 249.41 204.5 244.066 195C238.722 185.5 242.123 170 266.415 164C290.708 158 280.505 136 283.42 124.5Z",
    fill: "#00575F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.92 21.9997C193.052 9.5997 142.524 -11.8336 122.118 -21.0003C99.9311 -26.167 63.1361 -32.0003 93.4531 -14.0003C123.77 3.9997 198.396 17.4997 231.92 21.9997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.387 109C61.387 109 -0.153868 97.8333 -13.4337 92.5C-21.2073 94 -32.0903 98.6 -13.4337 105C5.22286 111.4 44.2203 110.333 61.387 109Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_620",
    x: -101,
    y: -95,
    width: 523,
    height: 249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8_620",
    x: -60.3019,
    y: -60,
    width: 363.868,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8_620",
    x: -60.3019,
    y: -60,
    width: 363.868,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8_620",
    x: 225.885,
    y: 82.5,
    width: 122.57,
    height: 154.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8_620",
    x: 69.9652,
    y: -38.1934,
    width: 173.955,
    height: 72.1931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_8_620",
    x: -35.735,
    y: 80.5,
    width: 109.122,
    height: 41.5115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_620",
    x1: -55.861,
    y1: -46.2366,
    x2: 496.058,
    y2: 76.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_620",
    x1: -24.5136,
    y1: -21.7243,
    x2: 348.337,
    y2: 60.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_620",
    x1: -24.5136,
    y1: -21.7243,
    x2: 348.337,
    y2: 60.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsBackgroundSmall);
export default __webpack_public_path__ + "static/media/rewards-background-small.db0ed1f7b1b6a878b1d7c4441658c06e.svg";
export { ForwardRef as ReactComponent };